import { useAuthContext } from "providers/Auth";
import { globalLinks, Links } from "../constants";
import { shouldShowGlobalLink } from "../utils";
import { NavLink } from "./NavLink";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { NotificationsNavLink } from "./NotificationsNavLink";
import { InboxNavLink } from "./InboxNavLink";

export const GlobalLinkSection = () => {
  const { Units, Properties, Property } = useUnitsPropertiesDictionary();
  const { type } = useAuthContext();

  const nameOverrides: Record<string, string> = {
    Units: Units,
    Properties: Properties,
    "Property groups": `${Property} groups`
  };

  if (!type.isBoomScreen && !type.isRentReporting) return;

  return (
    <div className="mb-3 px-4 relative">
      {globalLinks
        .filter(({ name }) => shouldShowGlobalLink(name, type))
        .map(({ to, name, Icon }) => {
          if (name === Links.NOTIFICATIONS)
            return (
              <NotificationsNavLink
                key={"globallinks" + to + name}
                name={name}
                to={to}
                Icon={Icon}
              />
            );

          if (name === Links.INBOX)
            return (
              <InboxNavLink
                key={"globallinks" + to + name}
                name={name}
                to={to}
                Icon={Icon}
              />
            );

          return (
            <NavLink key={"globallinks" + to + name} to={to} HugeIcon={Icon}>
              {nameOverrides[name] || name}
            </NavLink>
          );
        })}
    </div>
  );
};
